// Shared client-side file validation for upload spots (drag-drop + click pick).
// `accept` is the same comma-separated MIME list used on the native input's
// accept attribute; supports plain types ('image/png') and wildcards
// ('image/*'). `maxBytes` caps the file size. Returns { ok } or
// { ok: false, reason: 'type' | 'size' } so each caller can map its own copy.
export const validateUploadFile = (file, { accept = '', maxBytes } = {}) => {
  if (!file) return { ok: false, reason: 'type' };

  const allowed = accept
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);

  const typeOk =
    allowed.length === 0 ||
    allowed.some((rule) =>
      rule.endsWith('/*')
        ? file.type.startsWith(rule.slice(0, rule.indexOf('/*') + 1))
        : file.type === rule,
    );
  if (!typeOk) return { ok: false, reason: 'type' };

  if (maxBytes && file.size > maxBytes) return { ok: false, reason: 'size' };

  return { ok: true };
};

export const MB = 1024 * 1024;
